export const monthNames = [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre"
];
export const dayNames = [
    'Lun',
    'Mar',
    'Mie',
    'Jue',
    'Vie',
    'Sab',
    'Dom',
];

// Separador usado para almacenar varios talleres en el campo `taller` de un Pedido.
// Debe coincidir con TALLER_SEPARATOR del backend (proyectoback/proyectosdrf/models.py).
export const TALLER_SEPARATOR = ';';
// Límite de talleres seleccionables por solicitud (por seguridad y usabilidad).
export const MAX_TALLERES_SELECCION = 10;